export const VERIFICATION_HEADER = 'Verification';
export const MENUS_GROUP_NAME = 'Menus';
export const INVENTORY_GROUP_NAME = 'Inventory';
export const SERVE_GROUP_NAME = 'Serve';
export const VERIFICATION_SPECIAL_SORTING = [
  'Verification Configuration',
  'Verification Selection',
  'View Application Distribution',
  'Confirmation Review',
  'Selection Letters',
  'Results Input',
];

// Ordinal starts from 1 for sub groups
export const SUB_GROUP_ORDERINGS_BY_GROUP = {
  ADMINISTRATION: {
    'DISTRICT SETTINGS': 1,
    'SYSTEM SETTINGS': 2,
  },
  INVENTORY: {
    'ORDERS / PURCHASING': 1,
    RECEIVING: 2,
    'ON-HAND TRANSACTIONS': 3,
    'ITEM MAINTENANCE': 4,
    'TRUCK ROUTE MGMT': 5,
    'INVENTORY REPORTS': 6,
    'INVENTORY SETUP': 7,
    'CENTRAL KITCHEN': 8,
    'INVENTORY UTILITIES': 9,
  },
  'POST BETA RELEASE': {
    ADMINISTRATION: 1,
    REPORTS: 2,
    STUDENTS: 3,
    UTILITIES: 4,
  },
  REPORTS: {
    MENUS: 1,
    SERVING: 2,
    STUDENTS: 3,
    SYSTEM: 4,
  },
  STUDENTS: {
    VERIFICATION: 1,
  },
  UTILITIES: {
    EXPORT: 1,
    IMPORT: 2,
    MENUS: 3,
  },
};

export const SIDEBAR_MESSAGE_STATUS = {
  Starting: 0,
  Info: 1,
  Success: 2,
  Error: 3,
};

export const SIDEBAR_MESSAGE_STATUS_NAME = {
  [SIDEBAR_MESSAGE_STATUS.Starting]: 'starting',
  [SIDEBAR_MESSAGE_STATUS.Info]: 'info',
  [SIDEBAR_MESSAGE_STATUS.Success]: 'success',
  [SIDEBAR_MESSAGE_STATUS.Error]: 'error',
};

export const SIDEBAR_MESSAGE_NETWORK_INTERRUPTION = {
  Title: 'Network Interruption Detected',
  Description:
    'Real-Time updates have been temporarily disabled for the current jobs.',
};



// WEBPACK FOOTER //
// ./src/components/app/sidebar/Constants.js